module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.a2da25e8.ttf";